var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-show"},[_c('slider',{attrs:{"items":_vm.items,"config":_vm.config},scopedSlots:_vm._u([{key:"body",fn:function({ item, index }){return [_c('slide',{key:index,attrs:{"overlay":_vm.overlay,"paths":{
                    xlarge: item.xLargeFileUrl,
                    large: item.largeFileUrl,
                    medium: item.mediumFileUrl,
                    small: item.smallFileUrl
                }}},[_c('div',{staticClass:"caption",domProps:{"innerHTML":_vm._s(item.body)}})])]}},(_vm.items.length > 1)?{key:"navigation",fn:function(){return [_c('div',{staticClass:"swiper-pagination"})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }